module.exports = __webpack_public_path__ + "img/14.4831a2a6.jpg";